export const ASSET_LOOKUP = 'asset_name_event_type'
